import classNames from "classnames";
import { useEffect } from "react";
import { useAuthedRequest } from "shared/@auth/Auth";
import { DATE_FORMAT, TIME_FORMAT } from "shared/globals";
import { useLogger } from "shared/@hooks/useLogger";
import { RequestCache } from "shared/@hooks/useRequestCache";
import Loader from "shared/Loader";
import { Tab, TabContainer } from "shared/TabContainer";
import Table from "shared/Table";
import formatDate from "shared/@utils/formatDate";
import styles from "./index.module.css";
import {
  Danger as DangerIcon,
  Ok as OkIcon,
  Close as CancelIcon,
} from "react-ikonate";

function StatusBadge({ value }) {
  value = value.toLowerCase();

  switch (value) {
    case "cancelled":
      return (
        <span className={classNames(styles.statusBadge, styles.cancelled)}>
          <CancelIcon className={styles.statusBadgeIcon} />
          {value}
        </span>
      );
    case "failed":
      return (
        <span className={classNames(styles.statusBadge, styles.failed)}>
          <DangerIcon className={styles.statusBadgeIcon} />
          {value}
        </span>
      );
    case "processed":
      return (
        <span className={classNames(styles.statusBadge, styles.processed)}>
          <OkIcon className={styles.statusBadgeIcon} />
          {value}
        </span>
      );
    default:
      return <span className={styles.statusBadge}>{value}</span>;
  }
}

export default function MembershipHistory({ iboNumber }) {
  const cache = RequestCache.useContainer();
  const { data, loading, error } = useAuthedRequest(
    `/membership/downgrades/${iboNumber}`,
    null,
    cache
  );
  const { logError } = useLogger({ prefix: "DowngradeHistory" });

  useEffect(() => {
    if (error != null) logError(error);
  }, [error]);

  if (loading || data == null) {
    return <Loader />;
  }

  return (
    <div className={styles.container}>
      <TabContainer className={styles.tabs}>
        <Tab title="Membership Downgrades" value="membership">
          <Table className={styles.table}>
            <thead>
              <tr>
                <th>Date</th>
                <th>Time</th>
                <th>Status</th>
                <th>From → To</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              {data.membershipHistory.map((r) => (
                <tr>
                  <td className={styles.nowrap}>
                    {formatDate(r.processDate, DATE_FORMAT)}
                  </td>
                  <td className={styles.nowrap}>
                    {formatDate(r.processDate, TIME_FORMAT)}
                  </td>
                  <td className={styles.nowrap}>
                    <StatusBadge value={r.status} />
                  </td>
                  <td className={styles.nowrap}>
                    {r.currentType} → {r.newType}
                  </td>
                  <td className={styles.notes}>
                    {r.notes || <span className={styles.faded}>None</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Tab>
        <Tab title="Digital Delivery" value="delivery">
          <Table className={styles.table}>
            <thead>
              <tr>
                <th>Date</th>
                <th>Status</th>
                <th>From → To</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              {data.deliveryHistory.map((r) => (
                <tr>
                  <td className={styles.nowrap}>
                    {formatDate(r.processDate, DATE_FORMAT)}
                  </td>
                  <td className={styles.nowrap}>
                    <StatusBadge value={r.status} />
                  </td>
                  <td className={styles.nowrap}>
                    {r.currentType} → {r.newType}
                  </td>
                  <td className={styles.notes}>
                    {r.notes || <span className={styles.faded}>None</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Tab>
      </TabContainer>
    </div>
  );
}
